import { FilloutFullScreenEmbed } from "@fillout/react";

import "@fillout/react/style.css";

function FilloutMriFormPage() {
	
	return (
		<FilloutFullScreenEmbed
			filloutId={import.meta.env.VITE_PUBLIC_FILLOUT_FORM_ID}
			inheritParameters
		/>
	);
}

export default FilloutMriFormPage;
